// Module
var code = "<div class=\"component-editor-transformation\"></div>\n";
// Exports
module.exports = code;